import { render, staticRenderFns } from "./guessing-rules-gold.vue?vue&type=template&id=362bfb10&scoped=true&"
import script from "./guessing-rules-gold.vue?vue&type=script&lang=js&"
export * from "./guessing-rules-gold.vue?vue&type=script&lang=js&"
import style0 from "./guessing-rules-gold.vue?vue&type=style&index=0&id=362bfb10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362bfb10",
  null
  
)

export default component.exports